import {useState} from "react";
import {GlobalState} from "state/GlobalState";
import {ErrorHandling} from "helpers/error-handling";
import ConfirmDeletionDialog from "layouts/main/components/ConfirmDeletionDialog";
import {BannerApi} from "HtvApi/Api";

const BannerDeleteDialogButton = ({id, onConfirm}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState(null);

    const closeDialog = () => {
        setIsLoading(false);
        setData(null);
    };

    const confirmDelete = () => {
        setIsLoading(true);

        BannerApi.bannerDelete({id})
            .then(() => {
                GlobalState.setSuccess('Successful operation!', 'Banner deleted successfully!');
                closeDialog();
                onConfirm && onConfirm();
            })
            .catch(error => {
                ErrorHandling.GlobalStateError(error);
                closeDialog();
            });
    };

    const showConfirmDialog = (e) => {
        e.preventDefault();
        setIsLoading(true);

        BannerApi.bannerGet({id}).then(response => {
            setData({
                id: response.data.id,
                url: response.data.url,
                imageUrl: response.data.imageUrl
            });
            setIsLoading(false);
        }).catch(error => {
            ErrorHandling.GlobalStateError(error);
            closeDialog();
        });
    };

    const button =
        <button className="btn btn-sm btn-danger" onClick={e => showConfirmDialog(e)} data-banner-id={id}>
            <i className="far fa-trash-alt" /> Delete
        </button>

    if (data || isLoading) {
        return (
            <>
                {button}
                <ConfirmDeletionDialog
                    isLoading={isLoading}
                    title={data ? `Confirm deletion of banner with ID: ${data.id}` : ''}
                    description={
                        data
                            ? <>
                                <strong>Target:</strong> {data.url}<br />
                                <img
                                    src={data.imageUrl}
                                    style={{maxWidth: '640px', maxHeight: '480px'}}
                                    alt="Banner preview"
                                />
                            </>
                            : ''
                    }
                    onCancel={() => closeDialog()}
                    onConfirm={() => confirmDelete()}
                />
            </>
        );
    }

    return button;
};

export default BannerDeleteDialogButton;
